import axios from 'axios';

import {getHeaders} from './jilApiUtils';

let clientId, includeRoles, url;

/**
 * Configure JIL Global Admin Policies APIs
 *
 * @param {Object} config - The configuration object
 * @param {String} config.url - The root url for JIL Organizations Search api
 * @param {String} config.clientId - The identifier for application
 * @param {String[]} config.includeRoles - An array of admin roles to include in the request
 */
const configure = (config) => {
  ({url, clientId, includeRoles} = config);
};

/**
 * @description Get Global Admin policies
 * @param {Object} options Options
 * @param {String} options.orgId Organization ID
 * @returns {Object} JIL response that contains policy list
 */
const getPolicies = ({orgId}) =>
  axios.get(`${url}/v2/organizations/${orgId}/policies`, {
    headers: getHeaders({clientId, includeRoles}),
    params: {isArray: true},
  });

const jilGlobalAdminPolicies = {configure, getPolicies};

export default jilGlobalAdminPolicies;
